import AdminRouters from "./admin";
import UserRouters from "./user";

export const AdminRouter = AdminRouters;
export const UserRouter = UserRouters;
